import React from 'react';
import { IBooking } from '../../../../domain/booking/models/IBooking';
import { CancelBooking } from '../../cancel-booking/CancelBooking';
import { useCancelConfirmationUrl } from '../helpers/useCancelConfirmationUrl';
import { StyledAction } from './StyledAction';

interface ICancelActionProps {
	booking: IBooking;
}

export const CancelAction = ({ booking }: ICancelActionProps) => {
	const nextUrl = useCancelConfirmationUrl(booking);

	return (
		<StyledAction>
			<CancelBooking booking={booking} nextUrl={nextUrl} />
		</StyledAction>
	);
};
